<div class="nav-container">
  <nav id="main-menu-navigation" class="navigation-main">
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/Supervaisor-profile']"
      >
        <!-- <img src="assets/images/ava.png" class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/profile.svg"
          alt="profile icon"
          style="width: 24px"
        />
        <span>الملف الشخصي</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/Supervaisor-Specialist-view']"
      >
        <!-- <img
          src="assets/images/medical-file.png"
          class="img-fluid"
          alt="SEU"
        /> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          style="width: 24px"
        />

        <span> قائمة المتخصصين</span></a
      >
    </div>
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/SupervisorReports']"
      >
        <!-- <img
          src="assets/images/medical-file.png"
          class="img-fluid"
          alt="SEU"
        /> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          style="width: 24px"
        />

        <span>التقارير الطبية</span></a
      >
    </div>
  </nav>
</div>
